import tableEllipsis from './modules/tableEllipsis'
import tableToExcel from './modules/tableToExcel'
import browserType from './modules/browserType'
import downFile from './modules/downFile'
import {formDate,dateScope,datePickerOptions} from './modules/formDate'
import formMoney from './modules/formMoney'
import printHTML from './modules/printHTML'
import copyObject from './modules/copyObject'
import bankName from './modules/bankName'
import htmlToPdf from './modules/htmlToPdf'
import baseToBlob from './modules/baseToBlob.js'
import createPdfUrl from './modules/createPdfUrl.js'
import roundAndCeil from './modules/roundAndCeil.js'
import formatBankCardNumber from './modules/formatBankCard.js'
import refreshObj from './modules/refreshObj.js'
import filterSjhm from './modules/filterSjhm.js'
import filterYhkh from './modules/filterYhkh.js'
import filterZjhm from './modules/filterZjhm.js'

export default {
    tableEllipsis,
    tableToExcel,
    browserType,
    downFile,
    formDate,
    dateScope,
    datePickerOptions,
    formMoney,
    printHTML,
    copyObject,
    bankName,
    htmlToPdf,
    createPdfUrl,
    roundAndCeil,
    formatBankCardNumber,
    baseToBlob,
    filterSjhm,
    filterYhkh,
    filterZjhm,
    refreshObj
}



// WEBPACK FOOTER //
// ./src/static/js/utils/index.js